import axios from 'axios'

const mediaUrl = process.env.REACT_APP_MEDIABACKEND_URL

const getScreenshot = async (data) => {

    const response = await axios.post(mediaUrl + `/api`, data)

    return response.data
}

const mediaService = {
    getScreenshot,
}

export default mediaService